(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ruthluz-product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-pdp-thumb]');
    if (thumb) {
      var id = thumb.getAttribute('data-pdp-thumb');
      document.querySelectorAll('[data-pdp-slide]').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-pdp-slide') === id);
      });
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
      return;
    }

    var step = event.target.closest('[data-pdp-step]');
    if (step) {
      var input = step.parentElement.querySelector('[data-pdp-qty]');
      if (!input) return;
      var next = Math.max(1, Number(input.value || 1) + Number(step.getAttribute('data-pdp-step')));
      input.value = next;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
